/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpInstancesResponse } from './gcpInstancesResponse';
import { GcpSecretResponse } from './gcpSecretResponse';
import { GcpBucketsResponse } from './gcpBucketsResponse';
import { GcpServiceAccountResponse } from './gcpServiceAccountResponse';


export interface GcpResourcesInfo { 
    buckets?: Array<GcpBucketsResponse>;
    instances?: Array<GcpInstancesResponse>;
    secrets?: Array<GcpSecretResponse>;
    service_accounts?: Array<GcpServiceAccountResponse>;
}

